<template>
  <el-container>
    <el-header class="header">
     <div style="display: flex">
       <el-button type="text" @click="$router.push({path: '/merchant/service/product/comfyuiTheme'})" class="add"><i class="el-icon-arrow-left"></i> </el-button> <p style="padding-left: 10px">主题编辑器</p>
     </div>
    </el-header>
      <div class="body">
        <div style="padding-right: 20px">
          <el-form size="medium">
            <el-form-item label="输入照片:">
              <div style="display: flex;align-items: center">
                <div v-for="(inputImg, inputImgIndex) in inputImgList">
                  <div style="color: #666666">
                    输入 {{ inputImgIndex + 1}}
                  </div>
                  <div style="position: relative; width: 100px">
                    <el-image  :src="inputImg.url"
                               style="width: 100px; height: 100px; border-radius: 20px;" :preview-src-list="[inputImg.url]" fit="cover">
                      <template slot="error">
                        <div style="width: 100px; height: 100px; border-radius: 20px; background-color: #f2f6fc;display: flex;
                        align-items: center;justify-content: center;color: #666666">
                          未选择照片
                        </div>
                      </template>
                    </el-image>
                    <i @click="deleteInput(inputImgIndex)" v-if="inputImgIndex != 0"  class="el-icon-delete" style="position: absolute;top: 5px;right: 5px;color: rgba(246,70,70,0.85)"></i>
                  </div>
                  <div>
                    <el-select v-model="inputImg.url" @change="updateData" filterable placeholder="请选择" size="mini">
                      <el-option
                          v-for="(pic,index) in portraitList"
                          :key="pic.id"
                          :label="pic.name"
                          :value="pic.url">
                  <span style="float: left">
                    <el-image  style="width: 30px; height: 30px; border-radius: 20px" :src="pic.thumbUrl" :preview-src-list="[pic.url]" fit="cover"></el-image>
                  </span>
                        <span style="float: right; color: #8492a6; font-size: 13px">{{ pic.name }}</span>
                      </el-option>
                    </el-select>
                  </div>
                </div>
                <div style="padding-left: 20px">
                  <el-button  style="height: 40rpx" type="primary" size="small" @click="addInput">增加输入</el-button>
                </div>
              </div>
            </el-form-item>
            <el-form-item label="工作流组:">
              <div>
                <el-button type="primary" size="small" @click="addStep">添加步骤</el-button>
                <el-tabs v-model="editableTabsValue" type="card" editable @edit="handleTabsEdit">
                  <el-tab-pane
                      style="background-color: #F2F6FC"
                      v-for="(step,index) in form.steps" :key="index" :label="'步骤' + step.step" :name="step.step + ''">
                    <AigcThemeStep :data="step" :ref="'step' + step.step"
                                   :get-input="getInput"
                                   :input-img-list="inputImgList"
                                   :input-count="form.inputCount"
                                   :all-steps="form.steps"
                                   @update:data="updateStep(index, $event)"
                                   @step-done="stepDone">
                    </AigcThemeStep>
                  </el-tab-pane>
                </el-tabs>
              </div>
            </el-form-item>
            <el-form-item label="输出图片:">
              <el-image  v-for="pic in form.exampleImgs "  :src="pic" style="width: 100px; height: 100px; border-radius: 20px;padding-left: 10px" :preview-src-list="form.exampleImgs" fit="cover"></el-image>
            </el-form-item>
            <el-form-item label="主题名称:">
              <el-input placeholder="给主题一个名字" v-model="form.name"></el-input>
            </el-form-item>
            <el-form-item label="主题分类:">
              <el-select v-model="form.categoryId" placeholder="请选择">
                <el-option
                    v-for="item in categoryOptions"
                    :key="item.key"
                    :label="item.value"
                    :value="item.key">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="主题封面:">
              <upload-image v-model="form.cover" :max="1"></upload-image>
            </el-form-item>
            <el-form-item label="主题说明:">
              <el-input type="textarea" placeholder="用简短的话介绍主题"  :autosize="{ minRows: 2, maxRows: 4}" v-model="form.description"></el-input>
            </el-form-item>
          </el-form>
          <el-form style="margin-top: 20px">
            <el-form-item>
              <el-button type="primary" size="medium" @click="saveOrUpdateTheme">保存主题</el-button>
              <el-button type="warning" size="medium" @click="draw">生成预览</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
  </el-container>
</template>
<script>
import {
  addWorkflowTheme,
  getPortrait,
  getWorkflowThemeCategoryOptions, getWorkflowThemeInfo, updateWorkflowTheme
} from '@/api/merchant/service/project'
import UploadImage from '@/components/uploadImage/index.vue'
import { functions } from 'lodash/object'
import AigcThemeStep from '@/components/project/AigcThemeStep.vue'

/**
 * 富文本工具
 */

export default {
  name: 'aigcTheme',
  components: {
    UploadImage,
    AigcThemeStep
  },
  data () {
    return {
      id: this.$route.query.id,
      inputImgList: [{
        url: ''
      }],
      list: [],
      selectId: '',
      paramList: [],
      res: null,
      timer: null,
      activeName: 0,
      loading: null,

      form: {
        inputCount: 1,
        workflowId: null,
        name: '',
        cover: '',
        description: '',
        categoryId: '',
        exampleImgs: [], // 成片
        steps: []
      },
      categoryOptions: [],
      drawStatus: -2,
      queneCount: 0,
      waitTime: 0,
      drawInfo: {},
      checkpointList: [],
      samplerNameList: [],
      loraList: [],
      vaeList: [],
      schedulerList: [],
      weightTypeList: [],
      portraitList: [],
      editableTabsValue: '1'
    }
  },
  created () {
  },
  methods: {
    functions,
    addInput () {
      this.inputImgList.push({
        url: ''
      })
      this.form.inputCount += 1
    },
    deleteInput (index) {
      this.inputImgList.splice(index, 1)
      this.form.inputCount -= 1
    },
    updateData () {
      this.inputImgList = JSON.parse(JSON.stringify(this.inputImgList))
      // 强制更新
      this.$forceUpdate()
    },
    handleTabsEdit (targetName, action) {
      if (action === 'add') {
        this.addStep()
      } else {
      //   询问是否删除
        let that = this
        this.$confirm(`确定要删除「步骤 ${targetName}」？`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          that.deleteStep(targetName)
        })
      }
    },
    addStep () {
      let step = {}
      step.step = this.form.steps.length === 0 ? 1 : this.form.steps[this.form.steps.length - 1].step + 1
      step.needWaitOtherStep = 0
      this.editableTabsValue = step.step + ''
      this.form.steps.push(step)
    },
    deleteStep (step) {
      if (this.form.steps.length === 1) {
        return
      }
      let index = this.form.steps.findIndex(item => item.step + '' === step)
      if (index === -1) {
        return
      }
      console.log('index', index)
      this.form.steps.splice(index, 1)
      this.editableTabsValue = this.form.steps[0].step + ''
    },
    stepDone (step, imgs) {
    //   推送到所有 AigcThemeStep 组件
      let that = this
      that.form.exampleImgs = []
      console.log(' that.form', that.form.steps)
      this.form.steps.forEach(item => {
        let key = 'step' + item.step
        that.$refs[key][0].updateInput(true, step, imgs)
        if (item.enOutput && item.exampleImgs) {
          console.log('item.enOutput', item)
          let exampleImgs = JSON.parse(item.exampleImgs)
          exampleImgs.forEach(img => {
            that.form.exampleImgs.push(img)
          })
        }
      })
    },
    inputImgChange () {
      let that = this
      this.form.steps.forEach(item => {
        let key = 'step' + item.step
        that.$refs[key][0].updateInput(false, 0, [this.inputImg])
      })
    },
    getInput (useOtherStep, step) {
      if (useOtherStep) {
        let res = this.$refs['step' + step][0].getRes()
        if (res) {
          return res[0]
        }
      } else {
        return this.inputImg
      }
    },
    getWorkflowThemeCategoryOptions () {
      getWorkflowThemeCategoryOptions().then(res => {
        this.categoryOptions = res
        if (!this.id) {
          this.form.categoryId = res[0].id
        }
      })
    },
    updateStep (index, value) {
      this.$set(this.form.steps, index, value) // 使用 Vue 的 $set 方法更新数组中的值
    },
    saveOrUpdateTheme () {
      if (!this.form.name) {
        this.$message({
          type: 'error',
          message: '请输入主题名称'
        })
        return
      }
      if (!this.form.cover) {
        this.$message({
          type: 'error',
          message: '请上传主题封面'
        })
        return
      }
      if (!this.form.description) {
        this.$message({
          type: 'error',
          message: '请输入主题说明'
        })
      }
      this.form.params = JSON.stringify(this.paramList)
      if (!this.id) {
        addWorkflowTheme(this.form).then((res) => {
          this.$message({
            type: 'success',
            message: '保存成功'
          })
          this.$router.back()
        })
      } else {
        updateWorkflowTheme(this.id, this.form).then((res) => {
          this.$message({
            type: 'success',
            message: '更新成功'
          })
          this.$router.back()
        })
      }
    },
    imgChange (index, value) {
      console.log('value', value)
      console.log('index', index)
      this.paramList[index].value = value
      // 强制刷新
      this.$forceUpdate()
    },
    getMask (item) {
      let mask = []
      mask[item.min] = {
        style: {
          color: 'rgba(189,189,189,0.55)'
        },
        label: item.min + ''
      }
      mask[item.max] = {
        style: {
          color: 'rgba(189,189,189,0.55)'
        },
        label: item.max + ''
      }
      return mask
    },
    getList () {
      this.getWorkflowThemeCategoryOptions()
      getPortrait().then((res) => {
        this.portraitList = res
      })
      if (this.id) {
        getWorkflowThemeInfo(this.id).then((res) => {
          this.form = res
          this.inputImgList = []
          for (let i = 0; i < this.form.inputCount; i++) {
            this.inputImgList.push({
              url: ''
            })
          }
          this.editableTabsValue = res.steps[0].step + ''
        })
      } else {
        this.addStep()
      }
    },
    draw () {
    //   筛选出不需要等待的步骤 并启动
      let steps = this.form.steps.filter(item => item.needWaitOtherStep === 0)
      steps.forEach(item => {
        let key = 'step' + item.step
        this.$refs[key][0].draw()
      })
      let that = this
      // 筛选出需要等待的步骤 并延迟启动
      let waitSteps = this.form.steps.filter(item => item.needWaitOtherStep === 1)
      setTimeout(() => {
        waitSteps.forEach(item => {
          let key = 'step' + item.step
          that.$refs[key][0].draw()
        })
      }, 1000)
      //   弹窗提示
      this.$message({
        type: 'success',
        message: '启动成功,正在生成所有步骤...'
      })
    }
  },
  mounted () {
    this.getList()
  }
}
</script>
<style scoped>

.mask {
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  background: #ccc;
  z-index: 999;
}
.mask div {
   margin-top: 10px;
}

.gallery-ara {
  position: relative;
  margin-top: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 80vh;
  border: 2px solid #ccc;
  background: #f6f6f6;
  border-radius: 12px;
}

.header {
  position: fixed;
  background-color: white;
  width: 100%;
  z-index: 999;
  height: 60px;
  font-size: 16px;

  border-bottom: 1px solid rgba(189, 189, 189, 0.55)
}

.body {
  padding: 40px;
  margin-top: 40px;
}
#chart {
  width: 100%;
  min-height: 500px;
  margin-top: 20px;
  margin-left: 40px;
}
.gallery {
  display: flex;
  flex-wrap: wrap;
}
.gallery img {
  margin: 5px;
  max-width: 100%; /* 计算每张图片的最大宽度 */
  height: auto;
}
.gallery-item {
  flex: 1 0 30%; /* 每行显示三个图片，计算方式：100% / 3 - 一点边距 */
  margin: 2px;
  box-sizing: border-box;
}

.draggable-element {
  position: fixed;
  border-radius: 20px;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);
  background-color: #fff;
  padding: 40px;
  left: 60px;
  top: 50%;
  cursor: move;
  z-index: 999;
}
.disDiv {
  /* display: flex; */
  border: 1px dotted;
  padding-bottom: 20px;
}
</style>
